import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "loading"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_loading = _resolveComponent("van-loading");

  var _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createElementBlock("div", {
    id: "app",
    class: _normalizeClass($data.isIos ? 'ios-app' : !$data.isCn ? 'android-app not-cn-lang' : 'android-app')
  }, [!$data.loaded ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_loading, {
    size: "24",
    color: "#3F96F3"
  })])) : _createCommentVNode("", true), $data.loaded ? (_openBlock(), _createBlock(_component_router_view, {
    key: 1
  })) : _createCommentVNode("", true)], 2);
}